export default {"src":"/_next/static/media/volume-on.704b6d69.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};